module.exports = __webpack_public_path__ + "img/back.73e447af.png";